module.exports = __webpack_public_path__ + "static/media/myriad-pharmaceuticals-landing.d7e32b6c.png";